var _typeof = require("/home/guisjlender/ubuntu-development/workspace/mobicare/mcare-artemis-sdk/node_modules/@babel/runtime/helpers/typeof");

module.exports = function (it) {
  return _typeof(it) === 'object' ? it !== null : typeof it === 'function';
};